/* eslint-disable import/no-deprecated */
import React, { useContext } from 'react';
import { Typography } from '../Typography';
import { Context } from './Context';

export const BaseItem: React.FunctionComponent<
  Omit<React.ComponentProps<typeof Typography>, 'variant' | 'color'>
> = ({ children, ...rest }) => {
  const { typography } = useContext(Context);
  return (
    <Typography data-component="InfoListBaseItem" {...typography} {...rest}>
      {children}
    </Typography>
  );
};
